"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findSurveyConfigModule = exports.findPreSaveSurveyConfigModule = void 0;
const findPreSaveSurveyConfigModule = (modules = []) => {
    for (let index = 0; index < modules.length; index++) {
        const mod = modules[index];
        const found = mod.type === "PreSaveRelease"
            ? mod
            : (0, exports.findPreSaveSurveyConfigModule)(mod.modules);
        if (found) {
            return found;
        }
    }
};
exports.findPreSaveSurveyConfigModule = findPreSaveSurveyConfigModule;
const findSurveyConfigModule = (modules = [], type) => {
    for (let index = 0; index < modules.length; index++) {
        const mod = modules[index];
        const found = mod.type === type ? mod : (0, exports.findSurveyConfigModule)(mod.modules, type);
        if (found) {
            return found;
        }
    }
};
exports.findSurveyConfigModule = findSurveyConfigModule;
//# sourceMappingURL=utils.js.map